<template>
  <div class="w-full h-16 bg-white/95 backdrop-blur-md border-b border-slate-100 flex justify-between items-center px-4 shadow-sm space-x-2 sticky top-0 z-30">
    <img
      class="cursor-pointer w-7 h-7 transition-transform active:scale-95 hover:opacity-80"
      style="filter: invert(34%) sepia(85%) saturate(2250%) hue-rotate(210deg) brightness(95%) contrast(92%);"
      @click="goBack"
      src="~@/assets/icons/arrow-left-white.svg" alt="back">
    <div
      class="cursor-pointer h-10 flex items-center space-x-1 transition-transform active:scale-95"
      @click="goToHome"
    >
      <img
        class="h-10 w-auto"
        src="~@/assets/img/logogunsa.png" alt="logo gunsa">
      <img
        class="h-7 w-auto"
        src="~@/assets/img/logogunsalong.png" alt="logo gunsa long">
    </div>
    <img
      class="cursor-pointer w-7 h-7 transition-transform active:scale-95 hover:opacity-80"
      style="filter: invert(34%) sepia(85%) saturate(2250%) hue-rotate(210deg) brightness(95%) contrast(92%);"
      @click="shareApp" src="~@/assets/icons/share-network-white.svg" alt="share">
  </div>
</template>

<script>
import { share } from '@/utils/share'
import location from '@/mixins/location'
import { mapState } from 'vuex'
export default {
  name: 'AppHeader',
  mixins: [location],
  computed: {
    ...mapState('article', ['detail']),
    ...mapState('fellowship', {
      detailFellowship: 'detail'
    }),
    ...mapState('worship', {
      detailWorship: 'detail'
    }),
    detailArticleShareData () {
      return {
        title: this.detail.title,
        text: this.detail.summary,
        url: `https://gkigunsa.com/detail/${this.detail.id}`,
        image: this.detail.imageUrl
      }
    },
    detailFellowshipShareData () {
      return {
        title: this.detailFellowship.title,
        text: this.detailFellowship.summary,
        url: `https://gkigunsa.com/persekutuan/${this.detailFellowship.id}`,
        image: this.detailFellowship.imageUrl
      }
    },
    detailWorshipShareData () {
      return {
        title: this.detailWorship.title,
        text: this.detailWorship.info,
        url: `https://gkigunsa.com/persekutuan/${this.detailWorship.sequence}`,
        image: this.detailWorship.imageUrl
      }
    }
  },
  methods: {
    goBack () {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({
          name: 'Home'
        })
      }
    },
    shareApp () {
      if (this.isDetailArticle) share(this.detailArticleShareData)
      else if (this.isDetailFellowship) share(this.detailFellowshipShareData)
      else if (this.isWorship) share(this.detailWorshipShareData)
      else share()
    },
    goToHome () {
      this.$router.push({
        name: 'Home',
        query: this.$route.query
      })
    }
  }
}
</script>

<style scoped>

</style>
